import { useEffect } from "react";

// Sets the browser tab title while the calling page is mounted, restoring
// whatever title was active before it on unmount — so navigating away never
// leaves a stale title behind. Pass undefined/empty to leave the current
// title untouched (used by pages that don't yet have their data loaded).
export default function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
